export enum LogAttributeBucket {
	ATTRIBUTES = 'attributes',
	RESOURCES = 'resource',
	SCOPE = 'scope',
}

export enum LogDetailsAction {
	COPY = 'copy',
	FILTER_IN = 'filter-in',
	FILTER_OUT = 'filter-out',
	GROUP_BY = 'group-by',
	REPLACE_FILTER = 'replace-filter',
}
